export default {
  namespaced: true,
  modules: { },
  state: {},
  actions: {},
  mutations: {},
  getters: {},
};
